import { WifiOff } from 'lucide-react';
import { useNetwork } from '../context/NetworkContext';
import { cn } from '../lib/utils';

interface OfflineBannerProps {
  className?: string;
}

/**
 * Full-width banner displayed when the device is offline.
 * Shows a warning message and slides down from the top.
 */
export function OfflineBanner({ className }: OfflineBannerProps) {
  const { isOffline } = useNetwork();

  if (!isOffline) return null;

  return (
    <div
      className={cn(
        'flex items-center justify-center gap-2 bg-destructive px-4 py-2 text-sm text-destructive-foreground animate-slide-down',
        className
      )}
      role="alert"
    >
      <WifiOff className="h-4 w-4 flex-shrink-0" />
      <span>You&apos;re offline. Showing cached results.</span>
    </div>
  );
}
